// extracted by mini-css-extract-plugin
export default {"root":"card-button_root__lIhRD"};